import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

/**
 * Roles for the signed-in user. Backed by TanStack Query so the result
 * is cached across navigation and component remounts — no duplicate
 * `user_roles` fetches on every page transition.
 */
export const useUserRole = () => {
  const { user } = useAuth();
  const userId = user?.id ?? null;

  const { data, isLoading } = useQuery({
    queryKey: ["user_roles", userId],
    enabled: !!userId,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId!);
      if (error) throw error;
      return data ?? [];
    },
  });

  const roles = data ?? [];
  return {
    isAdmin: roles.some((r) => r.role === "admin" || r.role === "super_admin"),
    isSuperAdmin: roles.some((r) => r.role === "super_admin"),
    loading: !!userId && isLoading,
  };
};
